import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { SharedModule } from './../../shared/modules/shared.module';
import { RouterModule } from '@angular/router';

import { CoursesModule } from  './courses/courses.module';

import { CoursesComponent } from './courses/courses.component';
import { CredentialsMaintenanceComponent } from './credentials-maintenance.component';
import { ImportCourseComponent } from './import-course/import-course.component';
import { NotificationsService } from './../../shared/services/notifications.service';

@NgModule({
  imports: [
    SharedModule,
    CoursesModule,    
    RouterModule,
    MomentModule
  ],
  providers:[ NotificationsService ],
  declarations: [
    CoursesComponent,
    CredentialsMaintenanceComponent,
    ImportCourseComponent
  ]
})
export class CredentialsMaintenanceModule { }
